export const GENDER_TEXT = {
    male: "男",
    female: "女"
};

export const IMG_UPLOAD_TIP = "JPG/PNG格式、不小于256像素";

export const REG_EXP = {
    mobile: /^1\d{10}$/
};

export const CLIENT_TYPE_TEXT = {
    WEB: "网站",
    APP: "APP",
    OTHER: "其他"
};

export const OTP_LENGTH_TEXT = {
    4: "4位",
    6: "6位（推荐）",
    8: "8位（安全）"
};

export const OTP_EXPIRE_TEXT = {
    5: "5分钟（安全）",
    10: "10分钟（推荐）",
    20: "20分钟"
};

export const OTP_FAIL_TEXT = {
    5: "5次（安全）",
    10: "10次（推荐）",
    20: "20次"
};

export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_FORMAT = "YYYY-MM-DD";
